import { Divider } from "@mui/material";
import { HeaderMenuButtonRow } from "@src/appV2/redesign/components/HeaderMenuButton/HeaderMenuButtonRow";
import { Title } from "@src/appV2/redesign/components/Title";
import { type ReactNode } from "react";

interface MobileHomeHealthPageHeaderProps {
  /** The page headline, shown to the right of the mobile navigation menu button. */
  title: ReactNode;
}

/**
 * Shared headline for the Home Health & Hospice mobile pages: the page title next
 * to the inline mobile navigation menu button ({@link HeaderMenuButtonRow}),
 * followed by a divider. Centralizing it here keeps the navigation drawer
 * reachable from every HH&H mobile page and stops new pages from silently
 * dropping the menu button (GRO-2580).
 *
 * Renders a fragment, so the caller's header `Stack` keeps controlling the spacing
 * between this title row, the divider, and anything the page renders after them.
 */
export function MobileHomeHealthPageHeader({ title }: MobileHomeHealthPageHeaderProps) {
  return (
    <>
      <HeaderMenuButtonRow>
        <Title component="h5">{title}</Title>
      </HeaderMenuButtonRow>
      <Divider />
    </>
  );
}
